import React, { useState, useEffect, useMemo } from "react";
import { Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Sticky from "react-sticky-el";
import ReactGA from "react-ga4";
import {
  fetchPressRelease,
  fetchPublicationIds,
} from "../../../actions/filters-actions";
import {
  FILTER_NAMES,
  VERTICALS,
  CONSTANTS,
  REPORT_CATEGORIES,
  LANGUAGE_CODES,
  SOCIAL_SOURCES,
  REGIONAL_LANGUAGE,
  COOKIE,
} from "../../../constants/app-constant";
import {
  ArrowDownIcon,
  FilterIcon,
  MenuIcon,
} from "../../Icons/icons.component";
import {
  Journalist,
  Publication,
  Sentiments,
  ShareOfVoice,
  ThematicAnalysis,
  KeywordCloud,
  Geo,
  Reach,
  Influencers,
  TopPosters,
  Languages,
  CitySpecificReport,
  Platform,
  TwitterInsights,
  LinkedInInsights,
  FacebookInsights,
  InstagramInsights,
  TagAnalysis,
  ShareRetweet,
  ReplyComment,
  Attachment,
  Like,
  AuthorLike,
  MemberType,
  TypeofPost,
  AuthorFollowing,
  AuthorTweetCount,
  AuthorListed,
  AuthorCreationDetails,
} from "./AnalysisGroup";
import DateRangeFilter from "../Filters/DateRangeFilter";
import Filters from "../Filters/Filters";
import LazyLoad from "react-lazy-load";
import { httpGet } from "../../../utility/requestHelper";
import { unifiedEnvConfig } from "../../../constants/api-endpoint";
import {
  cityWidgetList,
  influencerWidgetList,
  journalistWidgetList,
  keywordWidgetList,
  publicationWidgetList,
  reachWidgetList,
  sovWidgetList,
  taWidgetList,
  tonalityWidgetList,
  topPostersWidgetList,
} from "./AnalysisGroup/filter-constant";
import {
  socialCityWidgetList,
  socialNewCityWidgetList,
  socialSentimentWidgetlist,
  socialSOVWidgetList,
  socialWordCloudWidgetList,
  socialLanguageWidgetList,
  socialCitySpecificWidgetList,
  socialPlatformWidgetList,
  socialTwitterWidgetList,
  socialLinkedInWidgetList,
  socialFacebookWidgetList,
  socialInstagramWidgetList,
  socialTagWidgetList,
  socialShareRetweetWidgetList,
  socialReplyCommentWidgetList,
  socialAttachmentWidgetList,
  socialLikeWidgetList,
  socialAuthorLikeWidgetList,
  socialMemberTypeWidgetList,
  socialTypeOfPostWidgetList,
  socialAuthorFollowingWidgetList
} from "./AnalysisGroup/social-filter-constant";
import {
  blogsAndForumCityWidgetList,
  blogsAndForumSentimentWidgetlist,
  blogsAndForumSOVWidgetList,
  blogsAndForumWordCloudWidgetList,
  blogsAndForumLanguageWidgetList,
  blogsAndForumTagWidgetList,
} from "./AnalysisGroup/blogs-forum-filters.-constant";
import {
  getConceptUserId,
  sortArrayOfObjects,
} from "../../../utility/common-methods";
import {
  SOCIAL_SOURCES_OPTIONS,
  TONALITY_FILTER,
} from "../../../constants/static-filter";
import ConceptLogo from "../../../assets/images/conceptbiu-logo.png";
import { fetchInlineFilter } from "../../../actions/widget-action";
import { getCookie } from "../../../utility/cookieProvider";
import {GACODE} from "../../../constants/app-constant";

const {
  V_PRINT,
  V_ONLINE,
  V_SOCIAL,
  V_PRINT_AND_ONLINE,
  V_BLOG,
  V_FORUM,
  V_BLOGS_AND_FORUMS,
  V_PRINT_AND_ONLINE_OLD
} = VERTICALS;

const isPrintAndOnline = (vertical) => {
  return (
    vertical.indexOf(VERTICALS.V_PRINT) !== -1 ||
    vertical.indexOf(VERTICALS.V_ONLINE) !== -1 ||
    vertical.indexOf(VERTICALS.V_PRINT_AND_ONLINE_OLD) !== -1
  );
};

export const ANALYSIS_VERTICAL_OPTIONS = [
  {
    value: V_PRINT_AND_ONLINE,
    label: "Print & Online",
  },
  {
    value: V_SOCIAL,
    label: "Social",
  },
  // TODO: commented for demo.
  // {
  //   value: V_BLOGS_AND_FORUMS,
  //   label: "Blogs & Forums",
  // },
];

const { EMPTY_ARRAY, EMPTY_STRING, EMPTY_OBJECT } = CONSTANTS;
const {
  EDITION,
  PUBLICATION_TYPE,
  ENTITY,
  PUBLICATION_IDS,
  TYPED_PUBLICATION_TEXT,
  REMOVE_PUBLICATION_TEXT,
  VERTICAL,
  PRESS_RELEASE,
  LANGUAGES,
  COUNTRIES,
  PLATFORM,
  TONALITY_MULT,
} = FILTER_NAMES;

const {
  PUBLICATION,
  JOURNALIST,
  KEYWORD_CLOUD,
  SOV,
  CITY,
  CITYNEW,
  INFLUENCERS,
  REACH,
  SENTIMENT,
  TOP_POSTERS,
  TOP_LANGUAGES,
  CITY_SPECIFIC_REPORT,
  TAG_ANALYSIS,
  THEMATIC_ANALYSIS,
  SHARE_RETWEET,
  REPLY_COMMENT,
  ATTACHMENT,
  LIKE,
  AUTHOR_LIKE,
  MEMBER_TYPE,
  TYPE_OF_POST,
  AUTHOR_FOLLOWING,
  AUTHOR_TWEET_COUNT,
  AUTHOR_LISTED,
  AUTHOR_CREATION_DETAIL,
} = REPORT_CATEGORIES;

const reportCategoryList = [
  {
    id: SOV,
    label: "Share of Voice",
    component: ShareOfVoice,
    widgetList: sovWidgetList,
  },
  {
    id: THEMATIC_ANALYSIS,
    label: "Thematic Analysis",
    component: ThematicAnalysis,
    widgetList: taWidgetList,
  },
  {
    id: PUBLICATION,
    label: "Publication",
    component: Publication,
    widgetList: publicationWidgetList,
  },
  {
    id: JOURNALIST,
    label: "Journalist",
    component: Journalist,
    widgetList: journalistWidgetList,
  },
  {
    id: CITY,
    label: "Geography",
    component: Geo,
    widgetList: cityWidgetList,
  },
  {
    id: SENTIMENT,
    label: "Sentiment",
    component: Sentiments,
    widgetList: tonalityWidgetList,
  },

  {
    id: KEYWORD_CLOUD,
    label: "Keyword Cloud",
    component: KeywordCloud,
    widgetList: keywordWidgetList,
  },
];

const blogsAndForumCategoryList = [
  {
    id: SOV,
    label: "Share of Voice",
    component: ShareOfVoice,
    widgetList: blogsAndForumSOVWidgetList,
  },
  {
    id: CITY,
    label: "World Map",
    component: Geo,
    widgetList: blogsAndForumCityWidgetList,
  },
  {
    id: SENTIMENT,
    label: "Sentiment",
    component: Sentiments,
    widgetList: blogsAndForumSentimentWidgetlist,
  },
  {
    id: KEYWORD_CLOUD,
    label: "Keyword Cloud",
    component: KeywordCloud,
    widgetList: blogsAndForumWordCloudWidgetList,
  },
  {
    id: TOP_LANGUAGES,
    label: "Top Languages",
    component: Languages,
    widgetList: blogsAndForumLanguageWidgetList,
  },
  {
    id: TAG_ANALYSIS,
    label: "Tag Analysis",
    component: TagAnalysis,
    widgetList: blogsAndForumTagWidgetList,
  },
];

const socialReportCategoryList = [
  {
    id: SOV,
    label: "Share of Voice",
    component: ShareOfVoice,
    widgetList: socialSOVWidgetList,
  },
  {
    id: SENTIMENT,
    label: "Sentiment",
    component: Sentiments,
    widgetList: socialSentimentWidgetlist,
  },
  // {
  //   id: CITY,
  //   label: "Geography",
  //   component: Geo,
  //   widgetList: socialCityWidgetList,
  // },
{
    id: CITYNEW,
    label: "Geography",
    component: Geo,
    widgetList: socialNewCityWidgetList,
  },
  {
    id: KEYWORD_CLOUD,
    label: "Keyword Cloud",
    component: KeywordCloud,
    widgetList: socialWordCloudWidgetList,
  },
  {
    id: TOP_POSTERS,
    label: "Top Contributors",
    component: TopPosters,
    widgetList: topPostersWidgetList,
  },
  {
    id: INFLUENCERS,
    label: "Key Influencer",
    component: Influencers,
    widgetList: influencerWidgetList,
  },
  {
    id: REACH,
    label: "Reach",
    component: Reach,
    widgetList: reachWidgetList,
  },
  {
    id: TOP_LANGUAGES,
    label: "Top Languages",
    component: Languages,
    widgetList: socialLanguageWidgetList,
  },
  {
    id: REPORT_CATEGORIES.PLATFORM,
    label: "Platform Wise Analysis",
    component: Platform,
    widgetList: socialPlatformWidgetList,
  },
  {
    id: REPORT_CATEGORIES.TAG_ANALYSIS,
    label: "Tag Analysis",
    component: TagAnalysis,
    widgetList: socialTagWidgetList,
  },
  {
    id: REPORT_CATEGORIES.TWITTER,
    label: "X Insights",
    component: TwitterInsights,
    widgetList: socialTwitterWidgetList,
  },
  {
    id: REPORT_CATEGORIES.LINKEDIN,
    label: "LinkedIn Insights",
    component: LinkedInInsights,
    widgetList: socialLinkedInWidgetList,
  },
  {
    id: REPORT_CATEGORIES.FACEBOOK,
    label: "Facebook Insights",
    component: FacebookInsights,
    widgetList: socialFacebookWidgetList,
  },
  {
    id: REPORT_CATEGORIES.INSTAGRAM,
    label: "Instagram Insights",
    component: InstagramInsights,
    widgetList: socialInstagramWidgetList,
  },
  // {
  //   id: SHARE_RETWEET,
  //   label: "Share/Retweet",
  //   component: ShareRetweet,
  //   widgetList: socialShareRetweetWidgetList,
  // },
  // {
  //   id: REPLY_COMMENT,
  //   label: "Reply/Comment",
  //   component: ReplyComment,
  //   widgetList: socialReplyCommentWidgetList,
  // },
  // {
  //   id: ATTACHMENT,
  //   label: "Attachment",
  //   component: Attachment,
  //   widgetList: socialAttachmentWidgetList,
  // },
  // {
  //   id: LIKE,
  //   label: "Like",
  //   component: Like,
  //   widgetList: socialLikeWidgetList,
  // },
  // {
  //   id: MEMBER_TYPE,
  //   label: "Member Type",
  //   component: MemberType,
  //   widgetList: socialMemberTypeWidgetList,
  // },
  // {
  //   id: TYPE_OF_POST,
  //   label: "Type of Post",
  //   component: TypeofPost,
  //   widgetList: socialTypeOfPostWidgetList,
  // },
  // {
  //   id: AUTHOR_FOLLOWING,
  //   label: "Author",
  //   component: AuthorFollowing,
  //   widgetList: socialAuthorFollowingWidgetList,
  // },
  // {
  //   id: AUTHOR_LIKE,
  //   label: "Author Like",
  //   component: Languages,
  //   widgetList: socialLanguageWidgetList,
  // },
  // {
  //   id: AUTHOR_TWEET_COUNT,
  //   label: "Author Tweet Count",
  //   component: AuthorTweetCount,
  //   widgetList: socialLanguageWidgetList,
  // },
  // {
  //   id: AUTHOR_LISTED,
  //   label: "Author Listed",
  //   component: AuthorListed,
  //   widgetList: socialLanguageWidgetList,
  // },
  // {
  //   id: AUTHOR_CREATION_DETAIL,
  //   label: "Author Creation Detail",
  //   component: Languages,
  //   widgetList: AuthorCreationDetails,
  // },
  // {
  //   id: CITY_SPECIFIC_REPORT,
  //   label: "City Specific Report",
  //   component: CitySpecificReport,
  //   widgetList: socialCitySpecificWidgetList,
  // },
  
];

export default function AnalysisMain() {
  ReactGA.initialize(GACODE);

  const dispatch = useDispatch();
  const [startRange, setStartRange] = useState(new Date());
  const [endRange, setEndRange] = useState(new Date());
  const [selectedTab, setSelectedTab] = useState(ANALYSIS_VERTICAL_OPTIONS[0]);
  const [selectedfilter, setSelectedFilter] = useState(undefined);
  const [applyFilterTS, setApplyFilterTS] = useState(new Date().getTime());
  const [showFilter, toggleFilter] = useState(false);
  const [hasWidgitInit, setHasWidgetInit] = useState(false);
  const [activeKey, setActiveKey] = useState([SOV]);
  const [languageList, setLanguageList] = useState([]);
  const [orderedLanguage, setorderedLanguage] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [commonParams, setCommonParams] = useState({});
  const [selectAll, setSelectAll] = useState(true);
  const entityState = useSelector(
    (state) => state.entityAndKeyWordsReducer || {}
  );
  const IsSocialFlag =
    useSelector(
      (state) =>
        state.entityAndKeyWordsReducer &&
        state.entityAndKeyWordsReducer.configuration
  ) || {};
  const {
    entityDetails: { entityList = EMPTY_ARRAY },
  } = entityState || EMPTY_OBJECT;
  const selectedClient =
    useSelector(
      (state) => state.clientReducer && state.clientReducer.selectedClient
    ) || EMPTY_OBJECT;
  const selectedClientId = selectedClient && selectedClient.id;
  const filterState =
  useSelector((state) => state.filterReducer) || EMPTY_OBJECT;
  const concept_uid = getCookie(COOKIE.CONCEPT_USER_ID);   
  if(selectedClientId != undefined && selectedClientId != '' && selectedClientId != null){
    ReactGA.set({ userId: selectedClientId+".0."+concept_uid });
    ReactGA.set({ 'user_id': selectedClientId+".0."+concept_uid });
  }
  let locationHrefNew = window.location.href;
  if(selectedClientId != undefined && selectedClientId != '' && selectedClientId != null){
      ReactGA.event({
        category: "Analysis",
        action: "Analysis-"+selectedClientId+".0."+concept_uid,
        label: locationHrefNew, // optional
        //value: selectedClient.id+"000"+concept_uid, // optional, must be a number
      });
  }

  const {
    publicationTypeFilter,
    entityFilter,
    editionFilter,
    reportsEntityFilter,
    socialEntityFilter,
    tonalityFilter,
  } = filterState;

  const [filters, setFilters] = useState({
    entity: EMPTY_ARRAY,
    publication: EMPTY_ARRAY,
    publication_type: EMPTY_ARRAY,
    typedPublication: EMPTY_STRING,
    edition: EMPTY_ARRAY,
    media_type: String(selectedClient.is_online_access) === "1" && String(selectedClient.is_print_access) === "1"?[V_PRINT, V_ONLINE]:(String(selectedClient.is_online_access) === "1"?[V_ONLINE]:(String(selectedClient.is_print_access) === "1"?[V_PRINT]:[V_PRINT_AND_ONLINE_OLD])),
    press_release: EMPTY_ARRAY,
    platform: EMPTY_ARRAY,
    country: EMPTY_ARRAY,
    languages: IsSocialFlag?.configuration?.language_metadata?(IsSocialFlag?.configuration?.language_metadata?.split(",")):Object.keys(REGIONAL_LANGUAGE),
    tonality: EMPTY_ARRAY,
  });
  const [widgetParams, setWidgetParams] = useState({});
  const { media_type, entity } = filters;
  const dateHash = `${startRange}${endRange}`;

  useEffect(() => {
    /* This is call the analysis only once at initial load. hence keeping the check to monitor that call is made just once.*/
    if (entity && entity.length && !hasWidgitInit && media_type) {
      handleApplyFilter();
      setHasWidgetInit(true);
    }
  }, [selectedClientId, entity]);

  useEffect(() => {
    setHasWidgetInit(false);
    if (selectedTab.value === V_PRINT_AND_ONLINE) {
      setActiveKey([SOV]);
      handleFilterSelect(VERTICAL, selectedClient.is_online_access === "1" && selectedClient.is_print_access === "1"?[V_PRINT, V_ONLINE]:(selectedClient.is_online_access === "1"?[V_ONLINE]:(selectedClient.is_print_access === "1"?[V_PRINT]:[])));
    }
    if (selectedTab.value === V_SOCIAL) {
      setActiveKey([SOV]);
      handleFilterSelect(VERTICAL, [V_SOCIAL]);
    }
    if (selectedTab.value === V_BLOGS_AND_FORUMS) {
      setActiveKey([SOV]);
      handleFilterSelect(VERTICAL, [V_BLOG, V_FORUM]);
    }
    setWidgetParams({
      ...widgetParams,
      selectedVertical: selectedTab.value,
    });
  }, [selectedTab]);

  useEffect(() => {
    initEntityFilter();
  }, [reportsEntityFilter, socialEntityFilter]);

  useEffect(() => {
    if (media_type) {
      const callPTypeApi = isPrintAndOnline(media_type);
      setFilters({
        publication: EMPTY_ARRAY,
        publication_type: EMPTY_ARRAY,
        typedPublication: EMPTY_STRING,
        edition: EMPTY_ARRAY,
        media_type: filters.media_type,
        languages: IsSocialFlag?.configuration?.language_metadata?(IsSocialFlag?.configuration?.language_metadata?.split(",")):Object.keys(REGIONAL_LANGUAGE),
        tonality: EMPTY_ARRAY,
        platform: Object.values(SOCIAL_SOURCES),
      });

      if (callPTypeApi) {
        if (!publicationTypeFilter) {
          dispatch(fetchPublicationIds(V_PRINT));
        }
      }
      initEntityFilter();
    }
  }, [media_type]);

  useEffect(() => {
    dispatch(fetchPressRelease(selectedClientId));
    fetchSocialLanguages();
  }, [selectedClient]);

  useEffect(() => {
    setWidgetParams({
      ...widgetParams,
      from_date: startRange,
      to_date: endRange,
    });
    initInlineFilters();
  }, [dateHash]);

  useEffect(() => {
    setWidgetParams((prevState) => {
      return {
        ...prevState,
        ...commonParams,
      };
    });
  }, [commonParams]);

  const initInlineFilters = () => {
    const { entity, edition } = filters;
    dispatch(
      fetchInlineFilter({
        client_id: selectedClientId,
        media_type: V_ONLINE,
        entity,
        edition,
        to_date: endRange,
        from_date: startRange,
      })
    );
  };

  const initEntityFilter = () => {
    const entityListForFilter = getEntityFilterList();
    if (entityListForFilter) {
      if (selectAll) {
        setFilters((prevFilters) => {
          return {
            ...prevFilters,
            entity: entityListForFilter.values.map((e) => e.id),
          };
        });
      } else {
        setFilters((prevFilters) => {
          return {
            ...prevFilters,
            entity: [],
          };
        });
      }
    }
  };

  const initLanguageFilter = () => {
    if (languageList) {
      if (selectAll) {
        setFilters((prevFilters) => {
          return {
            ...prevFilters,
            languages: languageList.map((l) => l.id),
          };
        });
      } else {
        setFilters((prevFilters) => {
          return {
            ...prevFilters,
            languages: IsSocialFlag?.configuration?.language_metadata?(IsSocialFlag?.configuration?.language_metadata?.split(",")):Object.keys(REGIONAL_LANGUAGE),
          };
        });
      }
    }
  };
  const initPlatformFilter = () => {
    if (selectAll) {
      setFilters((prevState) => {
        return {
          ...prevState,
          platform: SOCIAL_SOURCES_OPTIONS.map((s) => s.id),
        };
      });
    } else {
      setFilters((prevState) => {
        return {
          ...prevState,
          platform: [],
        };
      });
    }
  };

  const initTonalityFilter = () => {
    if (selectAll) {
      setFilters((prevState) => {
        return {
          ...prevState,
          tonality: TONALITY_FILTER.values.map((l) => l.id),
        };
      });
    } else {
      setFilters((prevState) => {
        return {
          ...prevState,
          tonality: [],
        };
      });
    }
  };

  const handleFilterSelect = (name, value, resetAll) => {
    switch (name) {
      case EDITION: {
        if (resetAll) {
          setFilters({ ...filters, edition: [] });
          return;
        }
        let tempEntity = [...filters.edition];
        const editionList = editionFilter.values || [];
        const selectedEdition = editionList.filter((el) => el.id == value)[0];
        const existingSelectedEdition = tempEntity.filter(
          (el) => el.id == value
        )[0];
        if (!existingSelectedEdition) {
          tempEntity.push(selectedEdition);
          setFilters({ ...filters, edition: tempEntity });
        } else {
          tempEntity = tempEntity.filter((el) => el.id !== value);
          setFilters({ ...filters, edition: tempEntity });
        }
        break;
      }

      case PUBLICATION_TYPE: {
        if (resetAll) {
          setFilters({
            ...filters,
            publication_type: [],
            typedPublication: "",
            publication: [],
          });
          return;
        }
        const tempPublicationType = [...filters.publication_type];
        const elmIndex = tempPublicationType.indexOf(value);
        if (elmIndex === -1) {
          tempPublicationType.push(value);
          setFilters({ ...filters, publication_type: tempPublicationType });
        } else {
          tempPublicationType.splice(elmIndex, 1);
          setFilters({ ...filters, publication_type: tempPublicationType });
        }
        break;
      }

      case ENTITY: {
        if (resetAll) {
          setFilters({ ...filters, entity: [] });
          return;
        }
        const tempEntity = [...filters.entity];
        const elmIndex = tempEntity.indexOf(value);
        if (elmIndex === -1) {
          tempEntity.push(value);
          setFilters({ ...filters, entity: tempEntity });
        } else {
          tempEntity.splice(elmIndex, 1);
          setFilters({ ...filters, entity: tempEntity });
        }
        break;
      }

      case PUBLICATION_IDS: {
        if (resetAll) {
          setFilters({ ...filters, publication: "", typedPublication: "" });
          return;
        }
        if (filters.publication.filter((e) => e.id === value.id)[0]) {
          return;
        }
        setFilters({
          ...filters,
          publication: [...filters.publication, value],
          typedPublication: "",
        });
        break;
      }

      case TYPED_PUBLICATION_TEXT: {
        setFilters({ ...filters, typedPublication: value });
        break;
      }

      case REMOVE_PUBLICATION_TEXT: {
        const updatedArr = filters.publication.filter((e) => e.id !== value.id);
        setFilters({ ...filters, publication: updatedArr });
        break;
      }

      case VERTICAL: {
        if (resetAll) {
          setFilters({ ...filters, media_type: "" });
          return;
        }
        setFilters({ ...filters, media_type: value });
        break;
      }

      case PRESS_RELEASE: {
        if (resetAll) {
          setFilters({ ...filters, press_release: "" });
          return;
        }
        setFilters({ ...filters, press_release: value });
        break;
      }

      case PLATFORM: {
        const { platform = [] } = filters;
        if (resetAll) {
          setFilters({ ...filters, platform: [] });
          return;
        }
        const tempPlatform = platform ? platform : [];
        const elmIndex = tempPlatform.indexOf(value);
        if (elmIndex === -1) {
          tempPlatform.push(value);
          setFilters({ ...filters, platform: tempPlatform });
        } else {
          tempPlatform.splice(elmIndex, 1);
          setFilters({ ...filters, platform: tempPlatform });
        }
        break;
      }
      case LANGUAGES: {
        if (resetAll) {
          setFilters({ ...filters, languages: [] });
          return;
        }
        const tempLanguages = [...filters.languages];
        const elmIndex = tempLanguages.indexOf(value);
        if (elmIndex === -1) {
          tempLanguages.push(value);
          setFilters({ ...filters, languages: tempLanguages });
        } else {
          tempLanguages.splice(elmIndex, 1);
          setFilters({ ...filters, languages: tempLanguages });
        }
        break;
      }

      case TONALITY_MULT: {
        if (resetAll) {
          setFilters({ ...filters, tonality: [] });
          return;
        }
        const tempTonality = [...filters.tonality];
        const elmIndex = tempTonality.indexOf(value);
        if (elmIndex === -1) {
          tempTonality.push(value);
          setFilters({ ...filters, tonality: tempTonality });
        } else {
          tempTonality.splice(elmIndex, 1);
          setFilters({ ...filters, tonality: tempTonality });
        }
        break;
      }
      default:
    }
  };

  const handleDateChange = (date, type) => {
    const formattedDate = new Date(date);
    if (type === "start") {
      setStartRange(formattedDate);
    } else {
      setEndRange(formattedDate);
    }
  };

  const resolveSentiment = (tone) => {
    const tempTone = TONALITY_FILTER.values.filter((t) => t.id == tone);
    if (tempTone && tempTone[0]) {
      return tempTone[0].value;
    }
    return null;
  };

  const handleApplyFilter = (e, isLimitChanged, customParams) => {
    if (customParams) {
      setStartRange(customParams.startDate);
      setEndRange(customParams.endDate);
    }
    setSelectedFilter(undefined);
    const {
      media_type,
      entity,
      publication,
      edition,
      publication_type,
      platform,
      tonality,
      languages,
      country,
      press_release,
    } = filters;
    initInlineFilters();
    let commonParams = {
      from_date: customParams ? customParams.startDate : startRange,
      to_date: customParams ? customParams.endDate : endRange,
      selectedVertical: media_type,
      topic_ids: entity,
      client_id: selectedClientId,
      user_id: getConceptUserId(),
    };
    const pAndOnline = isPrintAndOnline(media_type);
    if (pAndOnline) {
      commonParams = {
        ...commonParams,
        ...{
          selectedMainPublication: publication,
          publisher_type: publication_type,
          selectedMainEdition: edition,
          filterUpdateTS: new Date().getTime(),
          /* Since, the print and online graph api takes tonality ids as input.
          We need to map the names to ids in order to have modular code**/
          selectedMainSentiment: [...tonality],
          selectedMainPressRelease: press_release || null,
        },
      };
    }
    if (!pAndOnline) {
      commonParams = {
        ...commonParams,
        ...{
          channel_type: platform ? [...platform] : null,
          selectedMainSentiment:
            tonality && tonality.map((t) => resolveSentiment(t)),
          language: languages,
          selectedMainCountry: country,
        },
      };
    }
    setCommonParams(commonParams);
  };

  const showPrintFilters =
    media_type === V_PRINT || media_type === V_PRINT_AND_ONLINE;

  const getCurrentReportCategoryList = () => {
    if (selectedTab.value == V_PRINT_AND_ONLINE) {
      return reportCategoryList;
    }
    if (selectedTab.value == V_SOCIAL) {
      return socialReportCategoryList;
    }
    if (selectedTab.value == V_BLOGS_AND_FORUMS) {
      return blogsAndForumCategoryList;
    }
    return [];
  };

  const getEntityFilterList = () => {
    if (
      media_type.indexOf(V_SOCIAL.toString()) !== -1 ||
      media_type.indexOf(V_BLOG.toString()) !== -1 ||
      media_type.indexOf(V_FORUM.toString()) !== -1 ||
      media_type.indexOf(V_SOCIAL) !== -1 ||
      media_type.indexOf(V_BLOG) !== -1 ||
      media_type.indexOf(V_FORUM) !== -1
    ) {
      return socialEntityFilter;
    }
    if (
      media_type.indexOf(V_PRINT.toString()) !== -1 ||
      media_type.indexOf(V_ONLINE.toString()) !== -1 ||
      media_type.indexOf(V_PRINT_AND_ONLINE_OLD.toString()) !== -1 ||
      media_type.indexOf(V_PRINT) !== -1 ||
      media_type.indexOf(V_ONLINE) !== -1 ||
      media_type.indexOf(V_PRINT_AND_ONLINE_OLD) !== -1
    ) {
      return reportsEntityFilter;
    }
  };

  const handleOnAccordianClick = (id, index) => {
    let tActive = [id]
    setActiveKey(tActive)
    // if (activeKey.includes(id)) {
    //   setActiveKey(activeKey.filter(data => data !== id));
    // } else {
    //   let tmpArr = [...activeKey]
    //   tmpArr.push(id)
    //   setActiveKey(tmpArr);
    //   const targetElm = document.getElementById(id);
    //   const scrollElement = document.querySelector(".accordionListWrap");
    //   if (targetElm && scrollElement) {
    //     const position = targetElm.getBoundingClientRect().top || 0;
    //     setTimeout(() => {
    //       scrollElement.scrollTo({
    //         top: position - (120 - 20 * index),
    //         behavior: "smooth",
    //       });
    //     }, 300);
    //   } else {
    //   }
    // }
  };

  useEffect(() => {
    let tArr = []
    languageList &&
      languageList.forEach((e) => {
        if (Array.isArray(filters.languages) && filters.languages.length && filters.languages.includes(e.id))
          tArr.unshift(e);
        else
          tArr.push(e);
      })
    setorderedLanguage(tArr)
  },[languageList,filters.languages])

  let fetchSocialLanguages = () => {
    selectedClientId &&
      httpGet(
        `${unifiedEnvConfig.LANGUAGES}?client_id=${selectedClientId}&perPage=100&page=0`
      )
        .then((response) => {
          const {
            data: { data },
          } = response;
          let tempList =
            data &&
            data
              .map((l) => {
                if (l && l != "und" && l != "null") {
                  return {
                    id: l,
                    language_name: LANGUAGE_CODES[l] || l,
                    value: l,
                  };
                }
              })
              .filter(Boolean);
          tempList = sortArrayOfObjects(tempList, "language_name");
          setLanguageList(tempList);
        })
        .catch((e) => { });

    httpGet(
      `${unifiedEnvConfig.COUNTRIES}?client_id=${selectedClientId}&perPage=100&page=0`
    )
      .then((response) => {
        const {
          data: { data = [] },
        } = response;
        const sortedData = data.sort();

        setCountryList(
          sortedData.map((c, index) => {
            return { id: c, country_name: c, value: c };
          })
        );
      })
      .catch((e) => { });
  };

  return (
    <>
      <div className="mainContainer analysisContainer">
        <div className="dashboardHeader dashboardHeading">
          <div className="dashboardHeaderTop d-flex">
            <div className="dashboardMobileMenu">
              <button className="btn menuBtn" id="menuBtn">
                <MenuIcon />
              </button>
              <img src={ConceptLogo} width="32" height="32" />
            </div>
            <div className="dhLeft d-flex">
              <div className="dhLeftWrap d-flex align-items-center">
                <h1>Analysis</h1>
              </div>
            </div>
          </div>
          <div className="topFilterWrap">
            <div className="mobTopHeading">
              <h1>Analysis</h1>
              <Dropdown
                key={selectedTab.value}
                className="dashboardDropdown verticalOptionDropdown"
              >
                <Dropdown.Toggle variant="default">
                  {selectedTab.label || "Select Vertical"}
                  <ArrowDownIcon />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  {ANALYSIS_VERTICAL_OPTIONS.map((item) => {
                    return (
                      <Dropdown.Item
                        key={item.label}
                        onClick={() => {
                          setSelectedTab(item);
                          setSelectAll(true);
                        }}
                      >
                        {item.label}
                      </Dropdown.Item>
                    );
                  })}
                </Dropdown.Menu>
              </Dropdown>
            </div>
            <div className="titleRow analysisTitleRow">
              <div className="titleLeftWrap">
                <div className="filterWrap">
                  <Dropdown
                    key={selectedTab.value}
                    className="dashboardDropdown verticalOptionDropdown"
                  >
                    <Dropdown.Toggle variant="default">
                      {selectedTab.label || "Select Vertical"}
                      <ArrowDownIcon />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {ANALYSIS_VERTICAL_OPTIONS.map((item) => {
                        return (
                          <Dropdown.Item
                            onClick={() => {
                              setSelectedTab(item);
                              setSelectAll(true);
                            }}
                          >
                            {item.label}
                          </Dropdown.Item>
                        );
                      })}
                    </Dropdown.Menu>
                  </Dropdown>
                  <DateRangeFilter
                    handleDateChange={handleDateChange}
                    startRange={startRange}
                    endRange={endRange}
                    showShortCut
                    key="analysis"
                    minDate={selectedClient ? selectedClient.start_date : null}
                    maxDate={selectedClient ? selectedClient.end_date : null}
                  />
                  <button
                    onClick={() => toggleFilter(true)}
                    className="btn filterBtn"
                  >
                    <FilterIcon /> <span>Filters</span>
                  </button>
                </div>
              </div>
              <div className="rightBtnContainer">
                <button
                  onClick={() => toggleFilter(true)}
                  className="btn filterBtn"
                >
                  <FilterIcon /> <span>Filters</span>
                </button>
                <div
                  className={`filtersWrap sideFilterWrap ${showFilter ? "show" : "hide"
                    }`}
                >
                  <div className="filtersColumnWrap">
                    <Filters
                      toggleFilter={toggleFilter}
                      filters={filters}
                      setFilters={setFilters}
                      applyFilters={handleApplyFilter}
                      client_id={selectedClientId}
                      selectedVertical={selectedTab.value}
                      initEntityFilter={initEntityFilter}
                      initLanguageFilter={initLanguageFilter}
                      initPlatformFilter={initPlatformFilter}
                      initTonalityFilter={initTonalityFilter}
                      handleDateChange={handleDateChange}
                      startRange={startRange}
                      endRange={endRange}
                      isAnalysisMain
                      entityFilterList={getEntityFilterList()}
                      countryList={countryList}
                      languageList={orderedLanguage}
                      selectedTab={selectedTab.value}
                      hideDateRange
                      setSelectAll={setSelectAll}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {useMemo(() => (
          <React.Fragment key={selectedTab.value}>
            {widgetParams && !!Object.keys(widgetParams).length && (
              <div className="accordion accordionListWrap analysisAccordionWrap">
                {getCurrentReportCategoryList().map((rc, index) => {
                  if (!rc) {
                    return null;
                  }
                  return (
                    <div
                    key={Math.random()}
                      className={
                        activeKey !== rc.id
                          ? "customAccordionRow card"
                          : "customAccordionRow card active"
                      }
                    >
                      <Sticky
                        scrollElement=".accordionListWrap"
                        boundaryElement=".customAccordionRow"
                        style={{ position: "relative" }}
                        hideOnBoundaryHit={false}
                      >
                        <div
                          className={`card-header ${activeKey.includes(rc.id) ? "show" : ""
                            }`}
                          onClick={(e) => handleOnAccordianClick(rc.id, index)}
                          id={rc.id}
                        >
                          <button
                            id={rc.id}
                            type="button"
                            className="btn btn-link"
                          >
                            {rc.label}
                          </button>
                        </div>
                      </Sticky>

                      <div
                        className={`collapse ${!activeKey.includes(rc.id) ? "hide" : "show"
                          }`}
                      >
                        <LazyLoad>
                          <div className="card-body">
                            <rc.component
                              key={rc.id}
                              widgetParams={widgetParams}
                              applyFilterTS={applyFilterTS}
                              filters={filters}
                              widgetList={rc.widgetList}
                              startRange={startRange}
                              endRange={endRange}
                            />
                          </div>
                        </LazyLoad>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </React.Fragment>
        ),[widgetParams,applyFilterTS,filters,startRange,endRange,widgetParams,activeKey])}
      </div>
    </>
  );
}
